import type { ReactNode } from 'react';

import { PagePaths } from '@revelio/core';

interface IStep {
  id: string;
  title: string;
  path: ReportBuilderDeliverablePaths;
  description?: string | ReactNode;
}

export enum ReportBuilderDeliverablePaths {
  REPORT_TYPE = 'report_type',
  ENTITY = 'entity',
  CONFIRMATION = 'confirmation',
}

export const steps: IStep[] = [
  {
    id: 'report_type',
    title: 'Report Type',
    path: ReportBuilderDeliverablePaths.REPORT_TYPE,
  },
  {
    id: 'entity',
    title: 'Entity',
    path: ReportBuilderDeliverablePaths.ENTITY,
  },
  {
    id: 'confirmation',
    title: 'Confirmation',
    path: ReportBuilderDeliverablePaths.CONFIRMATION,
  },
];

export enum ReportBuilderStep {
  REPORT_TYPE = 0,
  ENTITY = 1,
  CONFIRMATION = 2,
}

export const getReportBuilderPath = (step: ReportBuilderStep) => {
  const reportBuilderPath = (stepIndex: number) => {
    const path = steps[stepIndex]?.path;
    if (path) {
      return `/${PagePaths.REPORT_BUILDER}/${path}`;
    }
    throw new Error(`Step ${stepIndex} not found in report builder.`);
  };

  if (step === ReportBuilderStep.REPORT_TYPE) {
    return reportBuilderPath(0);
  }
  if (step === ReportBuilderStep.ENTITY) {
    return reportBuilderPath(1);
  }
  if (step === ReportBuilderStep.CONFIRMATION) {
    return reportBuilderPath(2);
  }
  throw new Error(`Unknown report builder step: ${step}`);
};
